import React, { useState } from "react";
import ReadingTable from "./readingTable";
import InOutReadingTable from "./inOutReadingTable";

const initialColumns = [
  {
    id: "standardReading",
    label: "STANDARD READINGS",
    accessor: "standardReading",
    dataType: "text",
  },
  {
    id: "actualMeasuredReading",
    label: "ACTUAL MEASURED READINGS",
    accessor: "actualMeasuredReading",
    dataType: "text",
  },
  { id: "error", label: "ERROR", accessor: "error", dataType: "text" },
  {
    id: "acceptanceCriteria",
    label: "ACCEPTANCE CRITERIA",
    accessor: "acceptanceCriteria",
    dataType: "text",
  },
];

const initialData = [
  {
    standardReading: "",
    actualMeasuredReading: "",
    error: "",
    acceptanceCriteria: "",
  },
  {
    standardReading: "",
    actualMeasuredReading: "",
    error: "",
    acceptanceCriteria: "",
  },
];
const TestResult = () => {
  const [beforeCalibrationData, setBeforeCalibrationData] = useState(
    JSON.parse(JSON.stringify(initialData))
  );
  const [deletedRowIds, setDeletedRowIds] = useState([]);


  return (
    <div>
      TestResult
      <InOutReadingTable
        initialColumns={initialColumns}
        data={beforeCalibrationData}
        setData={setBeforeCalibrationData}
        srNo={true}
        deletedRowIds={deletedRowIds}
        setDeletedRowIds={setDeletedRowIds}
      />
    </div>
  );
};

export default TestResult;
